export type AppP2PInviteShareMethod = 'text' | 'email' | 'share';
export type WebP2PInviteShareMethod = 'copy' | 'text' | 'email' | 'share';
export type WebP2PInviteSource = 'desktop_invite' | 'mweb_invite';

/**
 * Marketing attribution attached to every P2P invite generated by the mobile app.
 * The medium is intentionally derived from the action used to generate the link.
 */
export const getAppP2PInviteUtmParams = (
    method: AppP2PInviteShareMethod
): Record<string, string> => ({
    utm_source: 'app_invite',
    utm_campaign: 'p2p_invite',
    utm_medium: method,
});

/**
 * Marketing attribution attached to every P2P invite generated on the web.
 * The medium is intentionally derived from the action used to generate the link.
 */
export const getWebP2PInviteUtmParams = (
    source: WebP2PInviteSource,
    method: WebP2PInviteShareMethod
): Record<string, string> => ({
    utm_source: source,
    utm_campaign: 'p2p_invite',
    utm_medium: method,
});
